import React, { Component } from 'react';

import RoutesSettingsForm from './RoutesSettingsForm';

import { defaultSorter } from './Helpers';
import RoutesModel from './RoutesModel';
import UserModel from './UserModel';

import { Table, Badge, Divider, Row, Col, Card, Popconfirm, Typography, message, Tag, Tooltip } from 'antd';

class RoutesTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    routesSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Card title="Popis">
              {record.description}
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Událost">
              {`application/routes/${record.routeName}/timeToDestination`}
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Body průjezdu (waypoints)">
            <br></br>
              {record.waypoints.map((waypoint, index) => {
                return (
                  <div key={waypoint}>
                    <Badge status="processing" text={waypoint} />
                    {index !== record.waypoints.length - 1 ? <Divider type="horizontal" /> : null}
                  </div>
                )
              })}
              <br></br>
            </Card>
          </Col>
        </Row>
      </div >
    );
  }

  render() {
    const columns = [{
      title: 'Cesta',
      dataIndex: 'routeName',
      key: 'routeName',
      width: 100,
      sorter: (a, b) => defaultSorter(a.routeName, b.routeName),
    }, {
      title: 'Začátek cesty',
      dataIndex: 'origin',
      key: 'origin',
      width: 180,
      render: (text, record) => {
        return (
          <Tooltip title={record.origin}>
            {record.description.split('>')[0]}
          </Tooltip>
        )
      }
    }, {
        title: 'Konec cesty',
        dataIndex: 'destination',
        key: 'destination',
        width: 180,
        render: (text, record) => {
          return (
            <Tooltip title={record.destination}>
              {record.description.split('>')[1]}
            </Tooltip>
          )
        }
      }, {
        title: 'Denní interval (min)',
        dataIndex: 'checkIntervalDay',
        key: 'checkIntervalDay',
        width: 160,
        sorter: (a, b) => defaultSorter(a.checkIntervalDay, b.checkIntervalDay),
      }, {
        title: 'Noční interval (min)',
        dataIndex: 'checkIntervalNight',
        key: 'checkIntervalNight',
        width: 160,
        sorter: (a, b) => defaultSorter(a.checkIntervalNight, b.checkIntervalNight),
      }, {
      title: 'Zobrazený text',
      dataIndex: 'displayedTime',
      key: 'displayedTime',
      width: 120,
      render: (text, record) => {
        if (record.displayedTime == 0) {
          return (
            <Tooltip title="Zhasnutá cedule"><Tag color='black'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Tag></Tooltip>
          )
        } else {
            return (
                <Tooltip title="Čas dojezdu"><Tag>{Math.floor(record.displayedTime / 60)} min {record.displayedTime % 60} sec</Tag></Tooltip>
            )
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 300,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'ROUTES_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  routesSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm
                placement="right"
                title="Opravdu si přejete tuto cestu smazat?"
                okText="Ano"
                cancelText="Ne"
                onConfirm={() => {
                  RoutesModel.remove(record.id)
                    .then(() => {
                      message.success('Cesta byla odstraněna!');
                      this.props.onRowRemoved();
                    })
                    .catch(() => {
                      message.error('Cestu se nepodařilo smazat!');
                    });
                }}>
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }]

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          onChange={this.handleChange}
          expandedRowRender={this.expandedRowRender.bind(this)}
          rowSelection={
            this.props.rowSelection !== undefined
              ? this.props.rowSelection
              : null
          }
        />

        <RoutesSettingsForm
          type="modal"
          modalVisible={this.state.routesSettingsFormData === null ? false : true}
          initialValues={this.state.routesSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ routesSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            RoutesModel.update(this.state.routesSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  routesSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default RoutesTable;


// WEBPACK FOOTER //
// ./src/components/RoutesTable.js